import { useQueryClient } from "@tanstack/react-query";

export const invalidateShopTrackingPreferencesQueryKey = (shopId: string) => [
	"get",
	"/shops/{shopId}/tracking/preferences",
	{ params: { path: { shopId } } },
];

export default function useInvalidateShopTrackingPreferencesSuspense() {
	const queryClient = useQueryClient();
	return (shopId: string) => {
		queryClient.invalidateQueries({
			queryKey: invalidateShopTrackingPreferencesQueryKey(shopId),
		});
	};
}
